export default __webpack_public_path__ + "static/media/979.7279d151.png";